import { API_URL } from '../config/apiConfig';
import { getAuthHeader, getUserInfo } from '../utils/tokenManager';

// 이 함수는 호텔 상품 목록을 가져옵니다.
export const getHotelProductList = async (companyNo, userNo) => {
  // Prefer token-derived values when not provided
  if (!companyNo || !userNo) {
    const u = getUserInfo() || {};
    companyNo = companyNo ?? u.companyNo;
    userNo = userNo ?? u.userNo;
  }
  const procedureName = 'DBO.TRP_S_투어상품리스트';
  const payload = {
    "Table1": [
      { "컬럼명": "@공급자번호", "값": String(companyNo) },
      { "컬럼명": "@유저번호", "값": String(userNo) }
    ]
  };

  try {
    const response = await fetch(`${API_URL}?procedureName=${procedureName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader()
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    // Filter by 상품종류코드 '001001' (호텔)
    const allProducts = data.table || [];
    return allProducts.filter(product => product.상품종류코드 === '001001');

  } catch (error) {
    console.error("Error fetching hotel product list:", error);
    throw error;
  }
};

// 이 함수는 상품 목록을 가져옵니다.
export const getProductList = async (companyNo, userNo) => {
  // Prefer token-derived values when not provided
  if (!companyNo || !userNo) {
    const u = getUserInfo() || {};
    companyNo = companyNo ?? u.companyNo;
    userNo = userNo ?? u.userNo;
  }
  const procedureName = 'DBO.TRP_S_투어상품리스트';
  const payload = {
    "Table1": [
      { "컬럼명": "@공급자번호", "값": String(companyNo) },
      { "컬럼명": "@유저번호", "값": String(userNo) }
    ]
  };

  try {
    const response = await fetch(`${API_URL}?procedureName=${procedureName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader()
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.table || [];

  } catch (error) {
    console.error("Error fetching product list:", error);
    throw error;
  }
};

// 이 함수는 상품의 상세 정보를 가져옵니다.
export const getProductDetails = async (productNo, companyNo) => {
  if (!companyNo) {
    const u = getUserInfo() || {};
    companyNo = u.companyNo;
  }
  const procedureName = 'DBO.TRP_S_투어_기본정보';
  const payload = {
    "Table1": [
      { "컬럼명": "@공급업체번호", "값": String(companyNo) },
      { "컬럼명": "@상품번호", "값": String(productNo) }
    ]
  };

  try {
    const response = await fetch(`${API_URL}?procedureName=${procedureName}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader()
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.table && data.table.length > 0 ? data.table[0] : null;

  } catch (error) {
    console.error("Error fetching product details:", error);
    throw error;
  }
};

// 호텔 상품 기본정보 조회 (기초설정 탭)
// 프로시저: DBO.TRP_S_%ED%98%B8%ED%85%94_%EA%B8%B0%EB%B3%B8%EC%A0%95%EB%B3%B4
export const getHotelBasicInfo = async (productNo, companyNo) => {
  if (!companyNo) {
    const u = getUserInfo() || {};
    companyNo = u.companyNo;
  }
  const procedureName = 'DBO.TRP_S_%ED%98%B8%ED%85%94_%EA%B8%B0%EB%B3%B8%EC%A0%95%EB%B3%B4';
  const payload = {
    "Table1": [
      { "컬럼명": "@공급업체번호", "값": String(companyNo), "리스트값": null },
      { "컬럼명": "@상품번호", "값": String(productNo), "리스트값": null }
    ]
  };

  try {
    const response = await fetch(`${API_URL}?procedureName=${procedureName}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader()
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.table && data.table.length > 0 ? data.table[0] : null;
  } catch (error) {
    console.error('Error fetching hotel basic info:', error);
    throw error;
  }
};

// 이 함수는 상품의 상세 정보를 업데이트합니다.
export const updateProductDetails = async (productData, companyNo) => {
  if (!companyNo) {
    const u = getUserInfo() || {};
    companyNo = u.companyNo;
  }
  const procedureName = 'DBO.TRP_U_투어_기본정보';
  
  const payload = {
    "Table1": [
        { "컬럼명": "@공급업체번호", "값": String(companyNo) },
        { "컬럼명": "@상품번호", "값": String(productData.상품번호) },
        { "컬럼명": "@상품명", "값": String(productData.상품명) },
        { "컬럼명": "@도시번호", "값": String(productData.도시번호) },
        { "컬럼명": "@상품타입", "값": String(productData.상품타입코드) },
        { "컬럼명": "@상품담당번호", "값": String(productData.상품담당번호) },
        { "컬럼명": "@예약담당번호", "값": String(productData.예약담당번호) },
        { "컬럼명": "@소요타입", "값": String(productData.소요타입) },
        { "컬럼명": "@소요시간", "값": String(productData.소요시간) },
        { "컬럼명": "@노출여부", "값": String(productData.노출여부) },
        { "컬럼명": "@키워드", "값": String(productData.키워드) }
    ]
  };

  try {
    const response = await fetch(`${API_URL}?procedureName=${procedureName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader()
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // 성공적으로 업데이트되었는지 확인하기 위해 응답을 반환할 수 있습니다.
    return await response.json();

  } catch (error) {
    console.error("Error updating product details:", error);
    throw error;
  }
};

// 이 함수는 모달의 기초정보를 저장 프로시저로 저장합니다.
// 프로시저: DBO.TRP_T_%ED%88%AC%EC%96%B4_%EA%B8%B0%EB%B3%B8%EC%A0%95%EB%B3%B4
// parameters:
// - companyNo: 공급업체번호 (string|number)
// - userNo: 유저번호 (string|number)
// - productNo: 상품번호 (string|number)
// - basicInfo: @기본정보에 들어갈 객체 (문자열화하여 전송)
// - keywords: @키워드 (쉼표로 구분된 문자열)
export const saveProductBasicInfo = async ({ companyNo, userNo, productNo, basicInfo, keywords }) => {
  if (!companyNo || !userNo) {
    const u = getUserInfo() || {};
    companyNo = companyNo ?? u.companyNo;
    userNo = userNo ?? u.userNo;
  }
  const procedureName = 'DBO.TRP_T_%ED%88%AC%EC%96%B4_%EA%B8%B0%EB%B3%B8%EC%A0%95%EB%B3%B4_01';
  const payload = {
    "Table1": [
      { "컬럼명": "@공급업체번호", "값": String(companyNo), "리스트값": null },
      { "컬럼명": "@유저번호", "값": String(userNo), "리스트값": null },
      { "컬럼명": "@상품번호", "값": String(productNo), "리스트값": null },
      { "컬럼명": "@기본정보", "값": JSON.stringify(basicInfo), "리스트값": null },
      { "컬럼명": "@키워드", "값": String(keywords || ''), "리스트값": null }
    ]
  };

  try {
    const response = await fetch(`${API_URL}?procedureName=${procedureName}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader()
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data; // { table: [...] }
  } catch (error) {
    console.error('Error saving product basic info:', error);
    throw error;
  }
};

// 호텔 기초설정 저장: DBO.TRP_T_호텔_기본정보_01
export const saveHotelBasicInfo = async ({ companyNo, userNo, productNo, basicInfo, keywords, web = true }) => {
  if (!companyNo || !userNo) {
    const u = getUserInfo() || {};
    companyNo = companyNo ?? u.companyNo;
    userNo = userNo ?? u.userNo;
  }
  const procedureName = 'DBO.TRP_T_%ED%98%B8%ED%85%94_%EA%B8%B0%EB%B3%B8%EC%A0%95%EB%B3%B4_01';
  const payload = {
    Table1: [
      { 컬럼명: '@공급업체번호', 값: String(companyNo), 리스트값: null },
      { 컬럼명: '@유저번호', 값: String(userNo), 리스트값: null },
      { 컬럼명: '@상품번호', 값: String(productNo), 리스트값: null },
      { 컬럼명: '@기본정보', 값: JSON.stringify(basicInfo || {}), 리스트값: null },
      { 컬럼명: '@키워드', 값: String(keywords || ''), 리스트값: null },
      { 컬럼명: '@웹', 값: !!web },
    ],
  };

  try {
    const response = await fetch(`${API_URL}?procedureName=${procedureName}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error saving hotel basic info:', error);
    throw error;
  }
};

// 호텔 상세정보 조회: DBO.TRP_S_호텔_상세정보
export const getHotelDetailInfo = async (productNo, companyNo) => {
  if (!companyNo) {
    const u = getUserInfo() || {};
    companyNo = u.companyNo;
  }
  const procedureName = 'DBO.TRP_S_%ED%98%B8%ED%85%94_%EC%83%81%EC%84%B8%EC%A0%95%EB%B3%B4';
  const payload = {
    "Table1": [
      { "컬럼명": "@공급업체번호", "값": String(companyNo), "리스트값": null },
      { "컬럼명": "@상품번호", "값": String(productNo), "리스트값": null }
    ]
  };

  try {
    const response = await fetch(`${API_URL}?procedureName=${procedureName}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader()
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return {
      detail: data.table && data.table.length > 0 ? data.table[0] : null,
      requestFields: data.table1 || []
    };
  } catch (error) {
    console.error('Error fetching hotel detail info:', error);
    throw error;
  }
};

// 호텔 상세정보 저장: DBO.TRP_T_호텔_상세정보
export const saveHotelDetailInfo = async ({ companyNo, userNo, productNo, detailInfo, requestFields = [] }) => {
  if (!companyNo || !userNo) {
    const u = getUserInfo() || {};
    companyNo = companyNo ?? u.companyNo;
    userNo = userNo ?? u.userNo;
  }
  const procedureName = 'DBO.TRP_T_%ED%98%B8%ED%85%94_%EC%83%81%EC%84%B8%EC%A0%95%EB%B3%B4';
  const payload = {
    Table1: [
      { 컬럼명: '@공급업체번호', 값: String(companyNo), 리스트값: null },
      { 컬럼명: '@유저번호', 값: String(userNo), 리스트값: null },
      { 컬럼명: '@상품번호', 값: String(productNo), 리스트값: null },
      { 컬럼명: '@상세정보', 값: JSON.stringify(detailInfo || {}), 리스트값: null },
      { 컬럼명: '@예약시받을정보', 값: JSON.stringify(requestFields || []), 리스트값: null }
    ],
  };

  try {
    const response = await fetch(`${API_URL}?procedureName=${procedureName}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error saving hotel detail info:', error);
    throw error;
  }
};
